'use client';

export default function CookiePage() {
  return (
    <iframe
      src="https://www.iubenda.com/privacy-policy/69421986/cookie-policy"
      className="w-full h-svh min-h-svh border-none"
      title="Cookie Policy"
    />
  );

  /*
  redirect('https://www.iubenda.com/privacy-policy/69421986/cookie-policy');
  */

  /*
  useSmoothScroll();

  return (
    <div className="min-h-screen overflow-x-hidden">
      <NavigationBar />
      <main className="flex min-h-screen flex-col pt-16 left-0 right-0">
        <LegalViewer htmlContent={cookieIt} />
        <Footer />
      </main>
    </div>
  );
  */
}
